import React from 'react';
import { VideoButton } from '../../components/VideoButton';

export const SettingsButton = (props) => {
    return <VideoButton name={'gear-six-shadow'} {...props} />
}
